var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useId } from '../hooks';
import { progressStyle, wrapperStyle, progressWrapperStyle } from './styles';
import Steps from './steps';
import Label from './label';
function Progress(_a) {
    var _b = _a.size, size = _b === void 0 ? 'medium' : _b, _c = _a.mode, mode = _c === void 0 ? 'continuous' : _c, _d = _a.variant, variant = _d === void 0 ? 'default' : _d, _e = _a.inverted, inverted = _e === void 0 ? false : _e, _f = _a.value, value = _f === void 0 ? 0 : _f, _g = _a.max, max = _g === void 0 ? 100 : _g, customLabel = _a.customLabel, _h = _a.hideLabel, hideLabel = _h === void 0 ? false : _h, ariaLabel = _a["aria-label"], restProps = __rest(_a, ["size", "mode", "variant", "inverted", "value", "max", "customLabel", "hideLabel", 'aria-label']);
    var progressId = "progress-".concat(useId());
    var isStepsMode = mode === 'steps';
    return (_jsxs("div", __assign({ "data-testid": "progress-wrapper", css: wrapperStyle({ size: size, inverted: inverted }) }, { children: [_jsxs("div", __assign({ css: progressWrapperStyle() }, { children: [isStepsMode && _jsx(Steps, { id: progressId, max: max, size: size }), _jsx("progress", __assign({ id: progressId, css: progressStyle({
                            size: size,
                            inverted: inverted,
                            variant: variant,
                            clipId: "".concat(progressId, "-clip"),
                        }), max: max, value: value, "aria-label": isStepsMode
                            ? ariaLabel.concat(' ', "".concat(Math.floor(value), " out of ").concat(max, " steps"))
                            : ariaLabel, "aria-valuemin": 0, "aria-valuenow": value, "aria-valuemax": max }, restProps))] })), !hideLabel && (_jsx(Label, __assign({}, { id: progressId, isStepsMode: isStepsMode, max: max, value: value, customLabel: customLabel })))] })));
}
export default Progress;
